import ShowcaseHeader from "@/components/sections/showcase/ShowcaseHeader";
import ShowcaseVideoPlayer from "@/components/sections/showcase/ShowcaseVideoPlayer";

export default function VideoShowcase({ t }) {
  return (
    <section
      id="showcase"
      className="py-20 sm:py-32 bg-white border-y border-[var(--border)]"
      data-testid="showcase-section"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-10">
        <ShowcaseHeader title={t.showcase.title} subtitle={t.showcase.subtitle} />
        <ShowcaseVideoPlayer t={t} />
      </div>
    </section>
  );
}
